export default __webpack_public_path__ + "static/media/platform.721321de.png";